import React, { useReducer } from "react";
import { Modal, Popup, Icon } from "semantic-ui-react";
import FormulairesAntecedents from "./FormulairesAntecedents";
import {
  initialState,
  reducer,
  ACTION,
} from "../../../Reducer/InitialStateReducer";

function Note(props) {
  const [state, dispatch] = useReducer(reducer, initialState);

  const { ID, userInformation, IsTablet, NewData, getQuestionsOneUser22 } =
    props;

  return (
    <>
      <Popup
        content="Antécédents du patient"
        trigger={
          <Icon
            circular
            inverted
            color="orange"
            onClick={() => dispatch({ type: ACTION.OPEN, size: "small" })}
            name="sitemap"
            size="large"
            className="centerIcon_And_Float_RightMod2"
          />
        }
      />
      <Modal
        size={state.size}
        open={state.open}
        onClose={() => dispatch({ type: ACTION.CLOSE })}
      >
        <Modal.Content>
          <FormulairesAntecedents
            getQuestionsOneUser22={getQuestionsOneUser22}
            NewData={NewData}
            ID={ID}
            userInformation={userInformation}
            IsTablet={IsTablet}
          />
        </Modal.Content>
      </Modal>
    </>
  );
}

export default Note;
